import {AuditService} from "../PA.Core/Security/AuditService";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {ProductBO} from "./ProductBO";
import {AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {esWB_Product_BOM, esWB_Product_Group, esWB_Product_Hierarchy, esWB_SalesArea} from "../PA.Core/PAdbSchema";
import * as _ from "lodash";
import {WB_FinishedProductSalesAreaRow} from "../PA.Core/PAdbSchemaRows";

export class ProductBOAudit {

    // Audit Log Service for Product

    static async ProductAuditBO(ProductBO: ProductBO): Promise<AuditService> {
        const self = ProductBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("Product", self.drWB_Product.cif.WB_PROD_ID)
        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

            //Adding new Product on screen
            const productParams: IAuditField [] = [
                {fieldName: "PRODUCT_ID", realName: "ID", bAllMsg: true }, //create
                {fieldName: "PRODUCT_NAME", realName: "Name"},
                {fieldName: "PRODUCT_SUBTYPE", realName: "SubType"},
                {fieldName: "PRODUCT_SET_ID", realName: "Set ID"},
                {fieldName: "SOURCE_ID", realName: "Source ID"},
                {fieldName: "PRODUCT_UPC", realName: ""},
                {fieldName: "CONSUMER_PRODUCT_UPC", realName: "Consumer UPC"},
                {fieldName: "STATUS_CODE", realName: "Status"},
                {fieldName: "UNIT_SIZE", realName: "Unit Size"},
                {fieldName: "UNIT_UOM", realName: "Unit UOM"},
                {fieldName: "ORDER_UOM", realName: "Order UOM"},
                {fieldName: "VOLUME_SIZE", realName: "Volume Size"},
                {fieldName: "VOLUME_UOM", realName: "Volume UOM"},
                {fieldName: "NET_WEIGHT", realName: "Net Weight"},
                {fieldName: "WEIGHT_UOM", realName: "Weight UOM"},
                {fieldName: "GROSS_WEIGHT", realName: "Gross Weight"},
                {fieldName: "NET_CONTENTS", realName: "Net Content"},
                {fieldName: "CONTENT_UOM", realName: "Content UOM"},
                {fieldName: "BASE_UOM", realName: "Base UOM"},

            ]

            //Product group
            const productGroupParams: IAuditField [] = [
                {fieldName: "WB_PRDGRP_ID_PRNT", realName: `Product Group,`,fkMapper: esWB_Product_Group,fkMapperNameField:"PRODUCT_GROUP_NAME",fkMapperIdField: "WB_PRDGRP_ID",bAllMsg: true},
                {fieldName: "WB_PRDH_ID",realName: "Hierarchy",fkMapper: esWB_Product_Hierarchy,fkMapperNameField: "HIERARCHY_ID",fkMapperIdField: "WB_PRDH_ID"},
                {fieldName: "EFFECTIVE_START_DT", realName: "Effective Start Date"},
                {fieldName: "EFFECTIVE_END_DT", realName: "Effective End Date"},
            ]
            const bomParams: IAuditField [] = [
                {fieldName: "WB_PROD_BOM_ID", realName: `Name`,fkMapper: esWB_Product_BOM,fkMapperNameField: "WB_PROD_ID",fkMapperIdField: "WB_PROD_ID",bAllMsg: true},
                {fieldName: "EFFECTIVE_START_DT", realName: "Effective Start Date"},
                {fieldName: "EFFECTIVE_END_DT", realName: "Effective End Date"},
            ]

        // Sales Area
        const productSalesArea: IAuditField[]= [
            {fieldName: "WB_SALESAREA_ID",
                fkMapper: esWB_SalesArea,
                fkMapperNameField: "SALESAREA_NAME",
                fkMapperIdField: "SALESAREA_ID",
                bAllMsg: true,
                realName: "Sales Area", },

        ]

            await AuditUtils.logRecord(auditService, self.drWB_Product, productParams,{objectName: 'Product', deletedKeys: deleteKeys})

            //Product group
            for(let aPrdGrpRow of self.drWB_Product.WB_FinishedProductRelationshipRows) {
                await AuditUtils.logRecord(auditService, aPrdGrpRow, productGroupParams, {objectName: 'Product Group',deletedKeys: deleteKeys})
            }
            //BOM
            for(let aPrdBOMRow of self.drWB_Product.WB_ProductBOMRows) {
                await AuditUtils.logRecord(auditService, aPrdBOMRow, bomParams, {objectName: 'BOM',deletedKeys: deleteKeys});
            }

        // Sales Area
        _.forEach(self.drWB_Product.WB_FinishedProductSalesAreaRows, async (aPrdGrpSalesAreaRow: WB_FinishedProductSalesAreaRow) => {
            await AuditUtils.logRecord(auditService, aPrdGrpSalesAreaRow, productSalesArea, {objectName: 'Sales Area', deletedKeys: deleteKeys})
        })

            return auditService
    }

}